// extracted by mini-css-extract-plugin
export default {"invoicesHeader":"styles_invoicesHeader__x89my","invoicesHeader_title":"styles_invoicesHeader_title__09col","invoicesHeader_actions":"styles_invoicesHeader_actions__JYFZ4"};